import { createSelector } from 'reselect';
import { MonitoringState } from '../types/store';

// Возвращает значения метрик мониторинга (Monitoring.monitoringMetrics)
export const monitoringMetricsSelector = createSelector(
  (state: { Monitoring: MonitoringState }) => state.Monitoring.monitoringMetrics,
  (monitoringMetrics) => monitoringMetrics
);
